













import Vue from "vue";
export default Vue.extend({
  props: {
    deviceTypeInput: { type: Number, default: null },
    isNoSelectDomain: { type: Boolean },
  },
  computed: {
    childDeviceTypeInput: {
      get(this: any) {
        return this.deviceTypeInput;
      },
      set(val) {
        return this.$emit("update:deviceTypeInput", val);
      },
    },
  },
});
